import type {
	ErrorEvent,
	Event,
	EventHint,
	TransactionEvent,
} from '@sentry/core'

const IGNORE = [
	'NEXT_REDIRECT',
	'NEXT_NOT_FOUND',
	'popup_closed',
	"Event 'Event' (type=error) captured as promise rejection",
	'Error invoking post: Method not found',
	'Unknown root exit status',
	'sendBeacon',
	'Expected client-id parameter in sdk url',
	'ERR_BLOCKED_BY_CLIENT',
	'fbq is not defined',
	'gtag is not defined',
	'Looks like your website URL has changed',
]

const AUTH = ['Failed to refresh token']

const NETWORK = [
	'Failed to fetch',
	'Load failed',
	'Network Error',
	/ChunkLoadError/,
]

const matches = (msg: string, list: (string | RegExp)[]) =>
	list.some((p) => (typeof p === 'string' ? msg.includes(p) : p.test(msg)))

const getMessage = (event: Event, hint?: EventHint) => {
	const ex = hint?.originalException
	return event.message || (ex instanceof Error ? ex.message : '') || ''
}

export const clientIgnoreErrors: (string | RegExp)[] = [...IGNORE]
export const serverIgnoreErrors: (string | RegExp)[] = [...IGNORE]
export const clientDenyUrls: (string | RegExp)[] = []
export const beforeSendTransaction = (
	event: TransactionEvent,
): TransactionEvent | null => event

export const beforeSend = (
	event: ErrorEvent,
	hint?: EventHint,
): ErrorEvent | null => {
	const msg = getMessage(event, hint)

	if (matches(msg, IGNORE)) return null

	if (matches(msg, AUTH)) {
		event.level = 'warning'
		return event
	}

	if (matches(msg, NETWORK)) {
		if (typeof navigator !== 'undefined' && !navigator.onLine) return null
		if (Math.random() > 0.2) return null
		return event
	}

	return event
}
